import { type PropsWithChildren, type ReactElement } from 'react'
import { Page } from '@components'

export const QuizPageContainer = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <Page className='h-[calc(100vh-(85px+var(--app-shell-header-offset,0rem)+var(--app-shell-padding)*2))]'>
      {children}
    </Page>
  )
}
